import { AdminRouteMap, InitialRouteMap } from '_constants';

const cleanRoute = (route: string, prop?: string) => {
  if (prop) {
    let newRoute = route.replace(/:(.*?)(?=\/)/, prop);
    return newRoute.replace(/\*/g, '');
  }
  return route.replace(/\*/g, '');
};
export const backRoute = () => window.history.back();

const isAdminRoute = (route: string): boolean => {
  const adminRoutes = Object.values(AdminRouteMap);
  return adminRoutes.includes(route);
};

export const constructRoute = (route: string, prop?: string): string => {
  if (isAdminRoute(route)) {
    return cleanRoute(InitialRouteMap.REST + route, prop);
  } else if (route.includes('exercise')) {
    return cleanRoute(InitialRouteMap.REST + AdminRouteMap.EXERCISES + route, prop);
  } else if (route.includes('challenge')) {
    return cleanRoute(InitialRouteMap.REST + AdminRouteMap.CHALLENGES + route, prop);
  } else if (route.includes('patient')) {
    return cleanRoute(InitialRouteMap.REST + AdminRouteMap.PATIENTS + route, prop);
  } else if (route.includes('resource')) {
    return cleanRoute(InitialRouteMap.REST + AdminRouteMap.RESOURCES + route, prop);
  } else if (route.includes('user')) {
    return cleanRoute(InitialRouteMap.REST + AdminRouteMap.USERS + route, prop);
  }
  return cleanRoute(route);
};
